import "./VersionHistory.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";

const VersionHistory = ({
    history,
    currentImage,
    onSelect
}) => {

    if (!history?.length) return null;

    return (

        <div className="version-card">

            <div className="version-header">

                <h3>Image Versions</h3>

                <span>{history.length} Versions</span>

            </div>

            <Swiper
                slidesPerView={4}
                spaceBetween={14}
                className="version-swiper"
                modules={[Navigation]}
                navigation
            >

                {history.map((item) => {

                    const active =
                        item.imageUrl === currentImage;

                    return (

                        <SwiperSlide
                            key={item.version}
                            className="version-slide"
                        >

                            <div
                                className={
                                    active
                                        ? "version-item active"
                                        : "version-item"
                                }
                                onClick={() => onSelect(item.imageUrl)}
                            >

                                <img
                                    src={item.imageUrl}
                                    alt=""
                                />

                                <div className="version-overlay">

                                    Version {item.version}

                                </div>

                            </div>

                        </SwiperSlide>

                    );

                })}

            </Swiper>

            <p style={{color: "white", textAlign: "center", marginTop: "10px"}}>Total Credits: {history.length*10}</p>
            <p style={{ color: "white", textAlign: "center", marginTop: "10px", fontSize: "11px" }}>Click the generated image to open it in the workspace, then edit it however you like.</p>

        </div>

    );

};

export default VersionHistory;